export default function({ baseModule }) {
  return {
    ...baseModule.mutations,

    SET_CURRENTS: (state, currents) => {
      state.currents = currents;
    },
    SET_CURRENT_REQUEST: (state, id) => {
      const newCurrent = {
        ...state.active,
        isLoading: true,
        id,
        data: {},
        recurrence: null,
        is_paused: null,
        daughter_request_id: null,
      };
      state.currents.push(newCurrent);
      state.active = newCurrent;
    },
    ADD_CURRENT_SUCCESS: (state, item) => {
      const index = state.currents.findIndex((el) => el.id === item.id);
      if (index >= 0) {
        state.currents[index].data = item.newCurrent;
        state.currents[index].isLoading = false;
        state.active = state.currents[index];
      }
    },
    SET_CURRENT: (state, item) => {
      const index = state.currents.findIndex((el) => el.id === item.id);
      if (index >= 0) {
        state.currents[index].data = item;
      }
    },
    SET_CURRENT_ACTIVE: (state, item) => {
      const index = state.currents.findIndex((el) => el.id === item.id);
      if (index >= 0) {
        if (item.recurrence) {
          state.currents[index] = {
            ...state.currents[index],
            recurrence: item.recurrence,
          };
        }
        if (item.is_paused) {
          state.currents[index] = {
            ...state.currents[index],
            is_paused: item.is_paused,
          };
        }
        if (item.daughter_request_id) {
          state.currents[index] = {
            ...state.currents[index],
            daughter_request_id: item.daughter_request_id,
          };
        }
        state.active = state.currents[index];
      }
    },
    CLEAR_ACTIVE: (state) => {
      state.active = {
        id: null,
        data: null,
        isLoading: false,
        error: null,
        recurrence: null,
        daughter_request_id: null,
      };
    },
    REMOVE_CURRENT: (state, id) => {
      const index = state.currents.findIndex((el) => el.id === id);
      if (index >= 0) {
        state.currents.splice(index, 1);
      }
    },
  };
}
